<template>
  <b-row>
    <b-col xl="8" md="7">
      <el-collapse v-model="activeNames">
        <b-row>
          <b-col lg="6" md="12" class="box-1 pl-0">
            <el-collapse-item title="Biểu đồ sự kiện ngày" name="1" class="chart">
              <template slot="title">
                <h6 class="ml-1 title-chart bold">Biểu đồ sự kiện ngày</h6>
              </template>
              <div @click="fn_goToEntryAndExitHistoryCompanyList" class="chart___block">
                <ChartJS
                  v-if="loaded"
                  :idChart="'CompanyMonth'"
                  :typeChart="'doughnut'"
                  :chartdata="chartdataEventDay"
                  :options="chartOptions"
                />
              </div>
            </el-collapse-item>
          </b-col>
          <b-col lg="6" md="12" class="box-2 pr-0">
            <el-collapse-item title="Biểu đồ sự kiện ngày" name="2" class="chart">
              <template slot="title">
                <h6 class="ml-1 title-chart bold">Biểu đồ có mặt tại công ty</h6>
              </template>
              <div class="chart___block doughnut_chart" @click="fn_goToEntryAndExitHistoryCompanyList">
                <ChartJS
                  v-if="loaded"
                  :idChart="'CompanyDay'"
                  :typeChart="'doughnut'"
                  :chartdata="chartdataCompanyDay"
                  :options="chartOptions"
                />
              </div>
            </el-collapse-item>
          </b-col>
        </b-row>
      </el-collapse>
      <b-row>
        <b-col xl="12" class="pl-0 pr-0 mb-3">
          <div class="card box-card box-card__navigation mt-3">
            <h5 class="mb-2">Điều hướng nhanh</h5>
            <b-row class="row__navigation">
              <!-- <b-col md="3" sm="6" class="mt-2"> -->
                <el-button
                  type="primary"
                  round
                  class="btn-default word-break-btn mb-2"
                  @click="fn_go('WorkRequest')"
                  >Thêm yêu cầu giải trình</el-button
                >
              <!-- </b-col>
              <b-col md="3" sm="6" class="mt-2"> -->
                <el-button
                  type="primary"
                  round
                  class="btn-default word-break-btn mb-2"
                  @click="fn_go('DayOffRequest')"
                  >Thêm yêu cầu xin nghỉ</el-button
                >
              <!-- </b-col>
              <b-col md="3" sm="6" class="mt-2"> -->
                <el-button
                  align="center"
                  type="primary"
                  round
                  class="btn-default word-break-btn mb-2"
                  @click="fn_go('WorkSheet')"
                  >Bảng công</el-button
                >
              <!-- </b-col>
              <b-col md="3" sm="6" class="mt-2"> -->
                <el-button
                  type="primary"
                  round
                  class="btn-default word-break-btn mb-2"
                  @click="fn_go('OnlineRequest')"
                  >Chấm công Online</el-button
                >
              <!-- </b-col> -->
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-col>
    <b-col xl="4" md="5">
      <div class="b-radius-15">
        <b-row>
          <b-col class="pl-0 pr-0 mb-3 b-shadow list-golate" v-if="mData.dataDefault.listEmployeeGoLate.length > 0">
            <div class="card box-card" style="box-shadow: 0 0 0 0">
              <b-row>
                <b-col md="12 pl-0 pr-0">
                  <div class="d-flex justify-content-between pl-1 pr-1">
                    <h5>Danh sách đi muộn:</h5>
                  </div>
                  <div style="border-bottom: 1px solid #bbb" class="mt-2 mb-3"></div>
                  <div class="mt-2 card-list-go-late" v-if="!loadListGoLate">
                    <div
                      class="d-flex align-items-center"
                      v-for="(item, index) in mData.dataDefault.listEmployeeGoLate"
                      :key="index"
                    >
                      <div class="icon__avt-circle">
                        <el-image
                          :src="item.avatar"
                          fit="cover"
                        ></el-image>
                      </div>
                      <p style="max-width: 70%">{{ item.employee_no }} - {{ item.employee_name }} - {{ item.first_time_log }}</p>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <HeaderCalendar :date="date" />
          <b-col md="12" class="calendar pl-0 pr-0 b-shadow">
            <Calendar
              :date="date"
            ></Calendar>
          </b-col>
        </b-row>
      </div>

    </b-col>
  </b-row>
</template>

<script>
import _ from "lodash";
import * as moment from "moment";
import DoughnutChart from "@/component/Chart/DoughnutChart";
import TimeKeepingRawCurrentApi from "../../../moduleApi/TimeKeepingRawCurrentApi";
import EmployeeRequestApi from '../../../moduleApi/EmployeeRequestApi';
import ShiftApi from "../../../moduleApi/ShiftApi";
import MethodService from "../../../service/MethodService";
import HeaderCalendar from "./HeaderCalendar.vue";
import ExtensionService from '../../../service/ExtensionService';
import ChartJS from '@/component/ChartJs/ChartJS';
import Calendar from "../../../component/Calendar";

export default {
  components: {
    DoughnutChart,
    HeaderCalendar,
    Calendar,
    ChartJS
  },
  props: {
    totalEmployee: {
      type: Number,
      default: null
    },
    shiftId: {
      type: String,
      default: null
    },
    employeeShift: {
      type: Array,
      default: () => {}
    },
    shiftInfo:{
      type: Object,
      default: () => {}
    },
    listEmployee:{
      type: Array,
      default: () => {[]}
    }
  },
  data() {
    return {
      listEmployeeProp: this.listEmployee,
      date: new Date(),
      loaded: true,
      activeNames: ["1", "2"],
      chartdataEventDay: {},
      chartdataCompanyDay: {},
      chartOptions: {},
      startDay: undefined,
      endDay: undefined,
      loadListGoLate: false,
      mData: {
        totalEmployee: 0,
        totalGoLate: 0,
        totalBusiness: 0,
        totalDayOff: 0,
        totalOnTime: 0,
        totalOnline: 0,
        totalEmployeeNoNeedCheckin: 0,
        totalHaveFace: 0,
        totalMissFace: 0,
        company: {},
        dataDefault: {
          listEmployeeRequest: [],
          listTimeKeepingRawCurrent: [],
          listEmployeeShift: [],
          listEmployee: [],
          listEmployeeOnTime: [],
          listEmployeeGoLate: [],
          employeeHaveFaces: [],
          listEmployeeNoNeedCheckin: [],
          listEmployeeRequestFilterOnline: [],
          listEmployeeRequestFilterDayOff: [],
          listEmployeeRequestFilterBussiness: [],
          listEmployeeRequestFilterGoLate: []
        }
      },
      year: 2022,
      month: 1,
      dayOfWeek: 0,
      weekCurrent: 0
    };
  },
  methods: {
    resetCountRequest(){
      this.mData.totalDayOff = 0;
      this.mData.totalOnline = 0;
      this.mData.totalBusiness = 0;
      this.mData.totalOnTime = 0;
      this.mData.totalGoLate = 0;
      this.mData.totalEmployeeNoNeedCheckin = 0;
      this.mData.totalHaveFace = 0;
      this.mData.totalMissFace = 0;
      this.mData.dataDefault.listEmployeeGoLate = [];
    },
    async fn_initData() {
      this.resetCountRequest();
      this.loaded = false;
      this.loadListGoLate = true;
      this.year = this.date.getFullYear();
      this.month = this.date.getMonth() + 1;
      this.dayOfWeek = this.date.getDay();
      this.startDay = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), 0, 0, 0).toISOString();
      this.endDay = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), 23, 59, 59).toISOString();
      let dataFilterTimeKeepingRaw = {
        filters: "time>=" + this.startDay + "&time<=" + this.endDay,
        limit: 9999999,
        sort: "-time"
      };
      let dataFilterEmployeeRequestOnDay = {
        cid: this.mData.company.id,
        sid: this.shiftId,
        sd: this.startDay,
        ed: this.endDay
      }
      Promise.all([
        TimeKeepingRawCurrentApi.list(
          dataFilterTimeKeepingRaw
        ),
        EmployeeRequestApi.getListEmployeeRequest(
          dataFilterEmployeeRequestOnDay
        )
      ]).then(res => {
        this.mData.dataDefault.listTimeKeepingRawCurrent =  res[0].result;
        this.mData.dataDefault.listEmployeeRequest = res[1].result;
        this.mData.dataDefault.listEmployeeNoNeedCheckin = this.fn_checkNoTimekeepingRequired(this.employeeShift);

        let arrTimeKeepingCurrentUnique = _.uniqBy(
          this.mData.dataDefault.listTimeKeepingRawCurrent,
          x => [x.employee_no].join()
        );
        let arrEmployeeCheckinAfterFilter = [];
        arrTimeKeepingCurrentUnique.forEach(x => {
          let check = this.listEmployeeProp.find(e => {
            return e.employee_no == x.employee_no
          })
          if (check) {
            x.employee_id = check.id;
            arrEmployeeCheckinAfterFilter.push(x);
          }
        })
        this.mData.dataDefault.employeeHaveFaces = $.map(arrEmployeeCheckinAfterFilter, function(n) {
            return n.employee_no;
          }
        );
        let listEmployeeRequestFilter = this.mData.dataDefault.listEmployeeRequest.filter(item => {
          return  (item.type == "DAY_OFF" && item.status == "APPROVED") ||
                  (item.type == "GO_ON_BUSSINESS" && item.status == "APPROVED") ||
                  (item.type == "TIME_KEEPING_ONLINE") ||
                  (item.type == "GO_LATE" && item.status == "APPROVED")
        })
        listEmployeeRequestFilter.forEach(item => {
          if (item.type == "GO_ON_BUSSINESS" && item.status == "APPROVED") {
            this.mData.dataDefault.listEmployeeRequestFilterBussiness.push(item);
            this.mData.totalBusiness++;
          }
          if (item.type == "DAY_OFF" && item.status == "APPROVED") {
            let dayOffShift = item.day_off.find(e => e.shift_id == this.shiftId && new Date(e.day).getTime() == new Date(this.startDay).getTime());
            if (
              dayOffShift &&
              (
                (dayOffShift.odd_shifts.length == 1 && dayOffShift.odd_shifts[0] == 1) ||
                (
                    dayOffShift.odd_shifts.length == 2 &&
                      ((dayOffShift.odd_shifts[0] == 1 && dayOffShift.odd_shifts[1] == 1) || (dayOffShift.odd_shifts[0] == 0 && dayOffShift.odd_shifts[1] == 1) || (dayOffShift.odd_shifts[0] == 1 && dayOffShift.odd_shifts[1] == 0))
                )
              )
            ) {
              this.mData.dataDefault.listEmployeeRequestFilterDayOff.push(item);
              this.mData.totalDayOff++;
            }
          }
          if (
            item.type == "TIME_KEEPING_ONLINE" && item.status != "REJECTED"
          ) {
            let checkHaveRequestWithEmployeeNoNeedCheckin = this.mData.dataDefault.listEmployeeNoNeedCheckin.find(e => e.employee_no == item.employee_no);
            if (checkHaveRequestWithEmployeeNoNeedCheckin) return
            this.mData.dataDefault.listEmployeeRequestFilterOnline.push(item);
            this.mData.totalOnline++;
          }
          if (item.type == "GO_LATE"  && item.status == "APPROVED") {
            this.mData.dataDefault.listEmployeeRequestFilterGoLate.push(item);
          }
        });
        let promises = this.listEmployeeProp.map(async item => {
          let checkExist = this.mData.dataDefault.listEmployeeNoNeedCheckin.find(x => {
            return x.employee_no == item.employee_no
          })
          if (checkExist) return
          return await this.fn_checkOnTime(this.dayOfWeek, item.employee_no, item.id); //employee_id nếu là lọc theo arrEmployeeCheckinAfterFilter
        });
        //Tính những người chưa có mặt
        let listEmployeeMissFaces = this.listEmployeeProp.filter(
          e => {
            return !this.mData.dataDefault.employeeHaveFaces.includes(
              e.employee_no
            );
          }
        );
        if (listEmployeeMissFaces && listEmployeeMissFaces.length > 0) {
          listEmployeeMissFaces.forEach(x => {
            let check = this.mData.dataDefault.listEmployeeGoLate.find(y => {
              return y.employee_no == x.employee_no;
            });
            if (!check) {
              this.mData.dataDefault.listEmployeeGoLate.push({
                avatar:
                  x.image_id ? ExtensionService.urlImg + x.image_id :
                  x.administrative_info &&
                  x.administrative_info.avatar_id ?
                  ExtensionService.urlImg + x.administrative_info.avatar_id : "img/user.png",
                employee_no: x.employee_no,
                employee_name:
                  x.administrative_info &&
                  x.administrative_info.name &&
                  x.administrative_info.name.full_name
                    ? x.administrative_info.name.full_name
                    : "Không rõ",
                first_time_log: "Chưa chấm công"
              });
            }
          });
        }
        Promise.all(promises).then(values => {
            // setTimeout(() => {
            this.mData.totalOnTime = values.filter(x => x).length;
            this.mData.totalMissFace = this.totalEmployee - this.mData.totalHaveFace;
            this.mData.totalEmployeeNoNeedCheckin = this.mData.dataDefault.listEmployeeNoNeedCheckin.length;
            this.mData.totalGoLate =
              this.totalEmployee -
              this.mData.totalOnTime -
              this.mData.totalEmployeeNoNeedCheckin -
              (this.mData.totalBusiness +
                this.mData.totalDayOff +
                this.mData.totalOnline)
              let arrFilter = [];
              let arrFilterIgnoreNoNeedCheckin = [];
              let arrFilterIgnoreBussiness = [];
              let arrFilterIgnoreDayOff = [];
              arrFilter = _.differenceBy(this.mData.dataDefault.listEmployeeGoLate, this.mData.dataDefault.listEmployeeRequestFilterOnline, 'employee_no');
              arrFilterIgnoreNoNeedCheckin = _.differenceBy(arrFilter, this.mData.dataDefault.listEmployeeNoNeedCheckin, 'employee_no');
              arrFilterIgnoreBussiness = _.differenceBy(arrFilterIgnoreNoNeedCheckin, this.mData.dataDefault.listEmployeeRequestFilterBussiness, 'employee_no');
              arrFilterIgnoreDayOff = _.differenceBy(arrFilterIgnoreBussiness, this.mData.dataDefault.listEmployeeRequestFilterDayOff, 'employee_no');
              this.mData.dataDefault.listEmployeeGoLate = arrFilterIgnoreDayOff;
              this.loadListGoLate = false;
              this.fn_setDataChart()
            this.$emit('done')
          // }, 1000)
        })
      })
    },
    fn_setDataChart() {
      this.chartOptions = {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          tooltip: {
            enabled: true
          },
          legend: {
            display: true,
            position: 'right',
            align: "center",
            labels: {
              textAlign: "left",
              usePointStyle: true,
              pointStyle: 'circle',
              font: {
                size: window.innerWidth > 1366 ? 14 : 12,
              },
              boxWidth: 50
            },
          },
          datalabels: {
            backgroundColor: 'white',
            borderColor: 'grey',
            borderRadius: 25,
            borderWidth: 3,
            color: 'black',
            display: false,
            font: {
              weight: 'bold',
              size: 18
            },
            padding: 90
          }
        },
        // Core options
        aspectRatio: 1.7,
        cutoutPercentage: 50
      }
      let dataEventDay = [];
      let dataCompanyDay = [];
      let labelsEventDay = [];
      let labelsCompanyDay = [];
      dataEventDay = [
        this.mData.totalGoLate,
        this.mData.totalBusiness,
        this.mData.totalDayOff,
        this.mData.totalOnTime,
        this.mData.totalOnline,
        this.mData.totalEmployeeNoNeedCheckin
      ];
      dataEventDay.forEach(e => {
        labelsEventDay.push(e)
      })

      dataCompanyDay = [
        this.mData.totalMissFace,
        this.mData.totalHaveFace
      ];
      dataCompanyDay.forEach(e => {
        labelsCompanyDay.push(e)
      })
      this.chartdataEventDay = {
        // labels: labelsEventDay,
        labels: ["Đi muộn", "Công tác", "Nghỉ phép", "Đúng giờ", "Online", 'VIP'],
        datasets: [
          {
            borderColor: 'white',
            borderWidth: 3,
            backgroundColor: [
              "#F79D61",
              "#007AFF",
              "#FF5A5A",
              "#29ff98",
              "#6600FF",
              "#1597e5"
            ],
            data: dataEventDay
          }
        ]
      };
      this.chartdataCompanyDay = {
        labels: ["Vắng mặt", "Có mặt"],
        datasets: [
          {
            borderColor: 'white',
            borderWidth: 3,
            backgroundColor: ["#616161", "#29ff98"],
            data: dataCompanyDay
          }
        ]
      };
      this.loaded = true;
    },
    async fn_checkOnTime(day, employeeNo, employeeId) {
      let check = undefined;
      let workDay = undefined;
      let dayOffFullDay = false;
      let dayOffFirstOddShift = false;
      let dayOffSeconOddShift = false;
      let haveDayOff = false;
      let firstTimeLog = undefined;
      let firstTimeOfShift = undefined;
      let endTimeOfShift = undefined;
      let firstTimeShiftDay = undefined;
      let endTimeShiftDay = undefined;
      //Check có yêu cầu đi muộn hay không
      let checkHaveRequestGoLate = this.mData.dataDefault.listEmployeeRequestFilterGoLate.find(request => request.employee_no == employeeNo);
      //Check dayoff thuộc loại nghỉ nào
      let checkDayOff = this.mData.dataDefault.listEmployeeRequestFilterDayOff.find(b => {
        return b.employee_id == employeeId;
      })
      if (checkDayOff) {
        haveDayOff = true;
        let checkDayoffOddDay = checkDayOff.day_off.find(c => {
          return c.shift_id == this.shiftId
        })
        if (checkDayoffOddDay) {
          if (
            (checkDayoffOddDay.odd_shifts.length == 1 && checkDayoffOddDay.odd_shifts[0] == 1) ||  //Check nếu odd_shift có dộ dài bằng 1 và phần tử đầu tiên == 1 => nghỉ cả ngảy
            (checkDayoffOddDay.odd_shifts.length == 2 && checkDayoffOddDay.odd_shifts[0] == 1 && checkDayoffOddDay.odd_shifts[1] == 1 )
          ) {
            dayOffFullDay = true;
            dayOffFirstOddShift = false;
            dayOffSeconOddShift = false;
          } else if (checkDayoffOddDay.odd_shifts.length == 2 && checkDayoffOddDay.odd_shifts[0] == 0 && checkDayoffOddDay.odd_shifts[1] == 1) {
            dayOffFullDay = false;
            dayOffFirstOddShift = false;
            dayOffSeconOddShift = true;
          } else if (checkDayoffOddDay.odd_shifts.length == 2 && checkDayoffOddDay.odd_shifts[0] == 1 && checkDayoffOddDay.odd_shifts[1] == 0) {
            dayOffFullDay = false;
            dayOffFirstOddShift = true;
            dayOffSeconOddShift = false;
          }
        }
      }
      if (haveDayOff === true && dayOffFullDay === true) {
        check = undefined;
        return
      }
      let emp = this.listEmployeeProp.find(x => {
        return x.employee_no == employeeNo;
      });
      if (!emp) return;
      let dayShift = (day + 1).toString();
      //Truyền thêm vào thời gian bắt đầu của ca, sau đó so sánh giờ
      if (this.shiftInfo.work_days && this.shiftInfo.work_days.length > 0) {
        workDay = this.shiftInfo.work_days.find(x => {
          return (
            ((x.period_time &&
              x.period_time[0] &&
              x.period_time[0].start_time &&
              x.period_time[0].start_time.hour) ||
              (x.period_time &&
                x.period_time[0] &&
                x.period_time[0].start_time &&
                !x.period_time[0].start_time.hour &&
                x.period_time &&
                x.period_time[1] &&
                x.period_time[1].start_time &&
                x.period_time[1].start_time.hour)) &&
            x.name == dayShift
          );
        });
      }
      if (workDay != undefined) {
        //Lấy giờ kết thúc của ca
        if (
          (workDay.period_time &&
          workDay.period_time[0] &&
          workDay.period_time[0].start_time &&
          workDay.period_time[0].start_time.hour) &&
          (workDay.period_time &&
          workDay.period_time[1] &&
          workDay.period_time[1].start_time &&
          workDay.period_time[1].start_time.hour)
        ) {
          firstTimeShiftDay = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[0].start_time.hour, workDay.period_time[0].end_time.minute + 1);
          endTimeShiftDay = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[1].end_time.hour, workDay.period_time[1].end_time.minute + 1);
        } else {
          firstTimeShiftDay = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[0].start_time.hour, workDay.period_time[0].end_time.minute + 1);
          endTimeShiftDay = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[0].end_time.hour, workDay.period_time[0].end_time.minute + 1);
        }
        //Check giờ bắt đầu/kết thúc của từng ca lẻ
        if (
          (workDay.period_time &&
          workDay.period_time[0] &&
          workDay.period_time[0].start_time &&
          workDay.period_time[0].start_time.hour) && haveDayOff == false
        ) {
          firstTimeOfShift = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[0].start_time.hour, workDay.period_time[0].start_time.minute + 1);
          endTimeOfShift = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[0].end_time.hour, workDay.period_time[0].end_time.minute + 1);
        } else if (
          (workDay.period_time &&
          workDay.period_time[0] &&
          workDay.period_time[0].start_time &&
          workDay.period_time[0].start_time.hour) && haveDayOff == true && dayOffSeconOddShift === true
        ) {
          firstTimeOfShift = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[0].start_time.hour, workDay.period_time[0].start_time.minute + 1);
          endTimeOfShift = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[0].end_time.hour, workDay.period_time[0].end_time.minute + 1);
          if (new Date().getTime() > firstTimeOfShift.getTime() && new Date().getTime() < endTimeOfShift.getTime()) {
            this.mData.dataDefault.listEmployeeRequestFilterDayOff = this.mData.dataDefault.listEmployeeRequestFilterDayOff.filter((el) => el.employee_id !== employeeId);
            this.mData.totalDayOff--;
          }
        } else {
          firstTimeOfShift = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[1].start_time.hour, workDay.period_time[1].start_time.minute + 1);
          endTimeOfShift = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[1].end_time.hour, workDay.period_time[1].end_time.minute + 1);
          if (new Date().getTime() > firstTimeOfShift.getTime() && new Date().getTime() < endTimeOfShift.getTime()) {
            this.mData.dataDefault.listEmployeeRequestFilterDayOff = this.mData.dataDefault.listEmployeeRequestFilterDayOff.filter((el) => el.employee_id !== employeeId);
            this.mData.totalDayOff--;
          }
        }
        if (checkHaveRequestGoLate) {
          firstTimeOfShift = checkHaveRequestGoLate.extra_minute_go_late;
        }
        //Nếu thời gian check in lớn hơn giờ bắt đầu của ca thì đi muộn và ngược lại
        firstTimeLog = this.fn_getFirstTimeLog(employeeNo,firstTimeOfShift);
        let currentTime = new Date().getTime();
        //Nghỉ sáng làm chiều
        if (haveDayOff === true && dayOffFirstOddShift === true && (currentTime > new Date(firstTimeOfShift).getTime() && currentTime < new Date(endTimeOfShift).getTime()) && firstTimeLog === null) {
          check = undefined;
        }
        //Nghỉ chiều làm sáng
        else if (haveDayOff === true &&  dayOffSeconOddShift === true && (currentTime < new Date(endTimeOfShift).getTime()) && firstTimeLog === null) {
          check = undefined;
        } else {
          if (
            !firstTimeLog ||
            (new Date(firstTimeLog).getTime() > new Date(firstTimeOfShift).getTime())
          ) {
            check = false;
          } else if (firstTimeLog && new Date(firstTimeLog).getTime() < new Date(firstTimeOfShift).getTime()) {
            check = true;
          }
          // lấy số lượng nhân viên có mặt
          if (
            new Date(firstTimeLog).getTime() <= new Date(firstTimeShiftDay).getTime() ||
            (new Date(firstTimeLog).getTime() <= new Date(endTimeShiftDay).getTime() &&
            new Date(firstTimeLog).getTime() >= new Date(firstTimeShiftDay).getTime())
          ) {
            if (dayOffFirstOddShift && (currentTime > new Date(firstTimeOfShift).getTime() && currentTime < new Date(endTimeOfShift).getTime())) {
              this.mData.totalHaveFace++;
            }
            if (dayOffSeconOddShift && (currentTime > new Date(firstTimeOfShift).getTime() && currentTime < new Date(endTimeOfShift).getTime())) {
              this.mData.totalHaveFace++;
            }
            if (dayOffFirstOddShift && (firstTimeLog && new Date(firstTimeLog).getTime() < new Date(firstTimeOfShift).getTime()) && (currentTime < new Date(firstTimeOfShift).getTime() || currentTime > new Date(endTimeOfShift).getTime())) {
              check = undefined;
            }
            if (dayOffSeconOddShift && (firstTimeLog && new Date(firstTimeLog).getTime() < new Date(firstTimeOfShift).getTime()) && (currentTime < new Date(firstTimeOfShift).getTime() || currentTime > new Date(endTimeOfShift).getTime())) {
              check = undefined;
            }
            if (!haveDayOff) {
              this.mData.totalHaveFace++;
            }
          }
        }

      }
      if (!check) {
        let emGoLate = this.mData.dataDefault.listEmployeeGoLate.find(e => {
          return e.employee_no == employeeNo;
        });
        if (!emGoLate) {
          let employee = this.listEmployeeProp.find(e => {
            return e.employee_no == employeeNo;
          });
          this.mData.dataDefault.listEmployeeGoLate.push({
            employee_no: employeeNo,
            avatar:
                  employee.image_id ? ExtensionService.urlImg + employee.image_id :
                  employee.administrative_info &&
                  employee.administrative_info.avatar_id ?
                  ExtensionService.urlImg + employee.administrative_info.avatar_id : "img/user.png",
            employee_name:
              employee &&
              employee.administrative_info &&
              employee.administrative_info.name &&
              employee.administrative_info.name.full_name
                ? employee.administrative_info.name.full_name
                : "Unknow",
            time: 1,
            first_time_log: firstTimeLog ? MethodService.formatDate(firstTimeLog, "datetime") : "Chưa chấm công"
          });
        }
      }
      // console.log("employeeNo", employeeNo, "check", check);
      return check;
    },
    fn_checkNoTimekeepingRequired(arrEmployeeShift){
      let arrNoNeedCheckin = [];
      let arr = [];
      arr = arrEmployeeShift.filter(x => {
        return x.is_need_checkin === false
      })
      arr.forEach(y => {
        let checkExist = arrNoNeedCheckin.find(z => {
          return z.employee_id == y.employee_id
        })
        let employee = this.listEmployeeProp.find(i => {
          return i.id == y.employee_id
        })
        if (!checkExist) {
          if (employee) {
            y.employee_no = employee.employee_no;
            arrNoNeedCheckin.push(y);
          }
        }
      })
      return arrNoNeedCheckin
    },
    fn_getFirstTimeLog(employeeNo,firstTimeOfShift) {
      let timeBefore = undefined;
      let timeAfter = undefined;
      let arrTimeBefore = this.mData.dataDefault.listTimeKeepingRawCurrent.filter(
        item => {
          return item.employee_no == employeeNo && new Date(item.time).getTime() < new Date(firstTimeOfShift).getTime();
        }
      );
      timeBefore = this.sortTimeDesc(arrTimeBefore)[0];
      let arrTimeAfter = this.mData.dataDefault.listTimeKeepingRawCurrent.filter(
        item => {
          return item.employee_no == employeeNo && new Date(item.time).getTime() > new Date(firstTimeOfShift).getTime();
        }
      );
      timeAfter = this.sortTimeAsc(arrTimeAfter)[0];
      return timeBefore != undefined ? timeBefore.time :
              timeAfter != undefined ? timeAfter.time : undefined;
    },
    //Sort giảm dần
    sortTimeDesc(arr){
      return arr.sort(function(a, b) {
        return new Date(b.time).getTime() - new Date(a.time).getTime();
      });
    },
    //Sort tăng dần
    sortTimeAsc(arr){
      return arr.sort(function(a, b) {
        return new Date(a.time).getTime() - new Date(b.time).getTime();
      });
    },
    fn_go(type) {
      if (type == "EmployeeList") {
        this.$router.push({
          name: "Admin-EmployeeManager-list"
        });
      } else if (type == "EmployeeRequestNeedApprove") {
        this.$router.push({
          name: "Admin-ManageRequests-RequestsWaitingForApproval"
        });
      } else if (type == "WorkRequest") {
        this.$router.push({
          name: "Admin-ManageRequests-ListRequests-WorkAdditionRequests"
        });
      } else if (type == "DayOffRequest") {
        this.$router.push({
          name: "Admin-ManageRequests-ListRequests-DayOffRequests"
        });
      } else if (type == "WorkSheet") {
        this.$router.push({
          name: "Admin-Timekeeping-Worksheet"
        });
      } else if (type == "OnlineRequest") {
        this.$router.push({
          name: "Admin-ManageRequests-ListRequests-TimeKeepingOnlineRequests"
        });
      }
    },
    refreshData(){
      this.fn_initData();
      window.setTimeoutY = setTimeout(() => {
        this.refreshData();
      }, 1000 * 300); //5 phút
    },
    fn_goToEntryAndExitHistoryCompanyList() {
      this.$router.push({
        name: "Admin-Timekeeping-TimekeepingConfig-EntryAndExitHistoryCompanyList",
        query: {
          fromTime: new Date(new Date().setHours(0,0,0)).toISOString(),
          toTime: new Date(new Date().setHours(23,59,59)).toISOString(),
        }
      }).catch(() => {});
    },
  },
  watch: {
    listEmployee(newVal) {
      this.listEmployeeProp = newVal
      if (window.setTimeoutY) clearTimeout(window.setTimeoutY)
      this.refreshData()
    }
  },
  created() {
    setTimeout(() => {
      this.mData.company = MethodService.getCompanyInfo();
      if (window.setTimeoutY) clearTimeout(window.setTimeoutY)
      this.refreshData()
    }, 200)

    // setTimeout(() => {
    //   this.refreshData()
    // }, 1200)
  },
  mounted() {
    $(".chart .el-collapse-item__wrap").click(function() {
      this.fn_goToEntryAndExitHistoryCompanyList();
    }.bind(this));
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-collapse-item__content {
  min-height: 295px;
}
::v-deep .vc-highlight{
  background-color: #f79e61 !important;
}
p{
  font-size: 14px;
}
.vc-container {
  border-color: #fff;
  border-radius: 0;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
.row__navigation{
  justify-content: space-between;
}
.box-card__navigation{
  padding: 25px !important;
}
.box-card-radius {
  border-radius: 0 0 15px 15px !important;
}
.icon__avt-circle {
  min-width: 42px;
  height: 42px;
  border-radius: 50%;
  margin: 5px 20px;
  .el-image{
    width: 42px;
    height: 42px;
    border-radius: 50%;
  }
}
.title-chart {
  color: #1E2027;
}
.word-break-btn {
  max-width: 250px;
  width: 210px;
  height: 50px;
  text-transform: none;
  font-size: 13px;
  white-space: normal;
  padding: 5px 5px;
}
.al-center {
  align-items: center;
}
.div_btn {
  padding: 10px;
  width: 200px;
  height: 45px;
  background: var(--white);
  box-shadow: 0px 0px 20px rgba(43, 43, 43, 0.131);
  border-radius: 25px;
}
.d-flex1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.fake_btn {
  width: 100%;
  padding: 5px;
  text-align: center;
  background: #fdfdfd;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.049);
  border-radius: 25px;
}
.fake_btn.active {
  background-color: rgb(60, 189, 248);
  color: #fff;
  letter-spacing: 0.01em;
  font-weight: 500;
  font-size: 12px;
  /* line-height: 14px; */
}
.fake_btn:hover {
  cursor: pointer;
}
.fake_btn span {
  font-size: 15px;
  font-weight: 400;
  color: orange;
}
.panel-group .card-panel {
  border-radius: 10px;
  height: 110px;
  cursor: pointer;
  font-size: 15px;
  position: relative;
  overflow: hidden;
  color: #666;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
  border-color: #c0c4cc;
}
.title-box_card {
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 600;
  line-height: 32px;
  position: absolute;
  top: 10px;
  left: 20px;
}
.icon {
  position: absolute;
  top: 30%;
  right: 10px;
}
.icon i {
  font-size: 35px;
}
.count {
  position: absolute;
  bottom: 15%;
  left: 20px;
  font-size: 35px;
  font-weight: bold;
  word-spacing: -5px;
  letter-spacing: -3px;
}
.box-shadow {
  box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
}
.card.box-card {
  padding: 15px;
  border-radius: 15px;
  box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
  border-color: #c0c4cc;
  background: #fff;
}
.card-list-go-late {
  max-height: 290px;
  overflow: auto;
}
.list-golate{
  border-radius: 20px;
}
::v-deep .calendar {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
::v-deep .el-collapse {
  border-top-color: transparent;
  border-top-width: 0;
  border-bottom-color: transparent;
  border-bottom-width: 0;
}
::v-deep .el-collapse .el-collapse-item__header {
  background-color: var(--white);
  border: 1px solid #c8ced3;
}
.circle{
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.ontime{
  background: #30DA88;
}
.bussiness{
  background: #00D1FF;
}
.offtime{
  background: #FF5A5A;
}
.golate{
  background: #F79D61;
}
.online{
  background: var(--purpleDark);
}
.missface{
  background: var(--gray);
}
.offtime{
  background: var(--red);
}
::v-deep .header_css{
  padding-left: 0 !important;
  padding-right: 0 !important;
  line-height: normal;
}
.el-button+.el-button{
  margin-left: 0;
}
@media (max-width: 992px) {
  .box-2 {
    margin-top: 16px;
    padding-left: 0;
  }
  .box-1 {
    margin-top: 16px;
    padding-right: 0;
  }
}
@media (max-width: 768px) {
  .calendar {
    margin-top: 10px;
  }
}
@media (max-width: 1660px) and (min-width: 1421px) {
  .word-break-btn {
    width: 170px;
  }
}
@media (max-width: 1420px) and (min-width: 1114px) {
  .word-break-btn {
    width: 135px;
  }
}
@media (max-width: 1114px) and (min-width: 1040px) {
  .word-break-btn {
    width: 180px;
  }
}
@media (max-width: 1039px) and (min-width: 768px) {
  .word-break-btn {
    width: 120px;
  }
}
@media (max-width: 547px) {
  .word-break-btn {
    width: 100%;
  }
  .row__navigation {
    flex-direction: column;
    align-items: center;
  }
}
</style>
